module.exports = "/fonts/boxicons.woff?deea39cb9dc8b17f9d640014ca2f87af";